import React from 'react';
import { StatCard } from './StatCard';
import { ICheckin, ICheckinTag } from '../model/ICheckin';
import { CheckinDetailsConfig, ICheckinDetailsType, typeToKey } from '../model/CheckinDetailsConfig';

interface IMostFrequentStatCardProps {
    description: string;
    type: ICheckinDetailsType,
    checkins: ICheckin[];
    'data-id'?: string;
}

export const MostFrequentStatCard: React.FC<IMostFrequentStatCardProps> = ({ description, type, checkins, 'data-id': dataId }) => {
    const config = CheckinDetailsConfig[type];

    // create a map of tag to count, e.g. { 'happy': 3 }
    const counts: {[tag in ICheckinTag]?: number} = {};
    for (const c of checkins) {
        const key = typeToKey[type];
        const tags = (c as any)[key] as ICheckinTag[];
        for (const tag of tags || []) {
            counts[tag] = (counts[tag] || 0) + 1;
        }
    }

    // pivot map into array, e.g. [ { tag: 'happy', count: 3 }], sorted by frequency, high to low
    const arr = ((Object.keys(counts) as unknown as ICheckinTag[])
        .map(tag => ({ tag, count: counts[tag] }))
        .sort((i1, i2) => (i2.count! - i1.count!) || i1.tag.localeCompare(i2.tag)));

    // first item in array is most frequent
    const mostFrequent = arr[0];

    const { Icon, activeColor } = (mostFrequent
        ? config.icons.find(i => i.label === mostFrequent.tag)
        : config.icons.find(i => i.isDefault) // fall back to default icon
    )!;

    return (
        <StatCard
            data-id={dataId}
            Icon={Icon}
            iconColor={activeColor}
            value={mostFrequent?.tag || '—'}
            description={description}
        />
    );
};
